const PAGE_TITLES = {
  //https://platform.dev.centra.ai/registration
  registration: 'Регистрация | Centra',

  //https://platform.dev.centra.ai/tasktracker
  tasktracker: (param: string[]) => `Задачи | Centra | ${param[0]}`,

  //Роли внутренние https://dev.authlb.centra.ai/
  taskList: 'Задачи | Centra',

  //https://platform.dev.centra.ai/task/1701
  task: (param: string[]) => `[${param[0]}] ${param[1]} | Centra | ${param[2]}`,

  createTask: 'Создание задачи | Centra',

  //https://platform.dev.centra.ai/profile
  profile: (param: string[]) => `Профиль | Centra | ${param[0]}`,

  //https://platform.dev.centra.ai/cabinet
  cabinet: (param: string[]) => `Пункт Управления | Centra | ${param[0]}`,

  //https://platform.dev.centra.ai/client/25
  client: (param: string[]) => `Клиент | ${param[0]} | Centra | ${param[1]}`,

  //https://platform.dev.centra.ai/clients
  clients: 'Клиенты | Centra',

  //https://dev.authlb.centra.ai/team
  team: (param: string[]) => `Моя Команда | Centra | ${param[0]}`,

  //https://dev.authlb.centra.ai/settings
  settings: (param: string[]) => `Настройки | Centra | ${param[0]}`,

  //https://dev.authlb.centra.ai/cabinet/payment
  payment: (param: string[]) => `Одновременное пополнение кабинетов | Centra | ${param[0]}`,

  adminStore: 'Витрина | Управление | Centra',

  //https://platform.dev.centra.ai/admin-store/add-product
  adminStoreAdd: `Добавление Продукта | Centra `,

  //https://platform.dev.centra.ai/admin-store/edit-product/63
  adminStoreEdit: (param: string[]) => `Редактирование | ${param[0]} | Centra`,
}

export const useTitle = (page: keyof typeof PAGE_TITLES, params: string[] = ['', '', '']) => {
  const title = PAGE_TITLES[page]

  document.title = typeof title === 'function' ? title(params) : title
}
